module.exports = __webpack_public_path__ + "img/COMBO HEART GREEN.e5d3172.svg";